import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AlertService } from '../../../_shared/services/alert.service';
import { UtilService } from '../../../_shared/services/util.service';

import { Facility } from '../../shared/facility.model';
import { FacilityService } from '../../shared/facility.service';

@Component({
  selector: 'app-facility-translation-modal',
  templateUrl: './facility-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class FacilityTranslationModalComponent {
  constructor(
    private alertService: AlertService,
    private utilService: UtilService,
    private facilityService: FacilityService,
    private formBuilder: FormBuilder,
    private ref: MatDialogRef<FacilityTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getFacility();
  }

  facility: Facility = null;
  facilityCopy = null;

  modalTitle = this.data.title;
  facilityId = this.data.obj.id;
  language = this.data.params.language;

  form: FormGroup;

  serverErrors = [];
  sendingForm = false;

  // Referenced from app-item-detail-form-actions
  onSavedFacilityTranslation() {
    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'description'];

    if (!fields.some((field) => formData[field] !== this.facilityCopy[field])) {
      this.close();
      return;
    }

    this.sendingForm = true;

    this.facilityService.saveFacility(this.facility.id, formData, this.language.lang).subscribe({
      next: (response) => {
        this.alertService.open('TRANSLATION_SAVED');

        this.sendingForm = false;

        this.ref.close(response);
      },
      error: (response) => {
        this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

        this.sendingForm = false;
      },
    });
  }

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getFacility() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.facilityService.getFacility(this.facilityId, params).subscribe((facility) => {
      this.facility = facility;
      this.facilityCopy = { ...this.facility };

      this.setFacilityTranslationForm();

      this.form.patchValue(this.facility);
    });
  }

  private setFacilityTranslationForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100),
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: '',
    });
  }
}

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

 this.form = this.formBuilder.group({
      name: [
        this.facility.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100),
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.facility.description],
    });

*/
